import { ColumnDef } from "@tanstack/react-table";
import { DashboardRankingsCity } from "../../types";

interface DashboardRankingsCitiesColumnsProps<TData> {
  translations: Record<string, string>;
}

export function DashboardRankingsCitiesColumns({
  translations,
}: DashboardRankingsCitiesColumnsProps<DashboardRankingsCity>): ColumnDef<DashboardRankingsCity>[] {
  return [
    {
      accessorKey: "position",
      header: translations.position,
      cell: (info) => `${info.getValue()}º`,
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: translations.name,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
    {
      accessorKey: "value",
      header: translations.value,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
  ];
}
